import { render } from "./BrandShow.vue?vue&type=template&id=66d30c56&scoped=true"
import script from "./BrandShow.vue?vue&type=script&lang=js"
export * from "./BrandShow.vue?vue&type=script&lang=js"

import "./BrandShow.vue?vue&type=style&index=0&id=66d30c56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d30c56"]])

export default __exports__